import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 48px 56px;
  background: #fff;
`;
export const Title = styled.h4`
  font-weight: 500;
  font-size: 40px;

  color: #292d32;
`;
export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 135%;
  color: #292d32;
  margin-top: 16px;
  opacity: 0.75;
  max-width: 408px;
`;
export const Icons = styled.div`
  display: flex;
  margin-top: 32px;
`;
export const FormContent = styled.div`
  margin-top: 32px;
`;
export const Label = styled.label`
  display: block;
  font-weight: 500;
  font-size: 16px;
  margin: 12px 0;
  color: #292d32;
`;
export const IconWrapper = styled.div`
  background: #466afb;
  padding: 5px;
  border-radius: 4px;
  margin-left: 24px;
  &:first-child {
    margin-left: 0;
  }
  img {
    object-fit: cover;
    width: 16px;
    height: 16px;
  }
`;
export const ImageWrapper = styled.div`
  border-radius: 8px;
  img {
    width: 416px;
    height: 650px;
    object-fit: contain;
  }
`;